export const ENTITY_TYPES = [
  { value: 'person', label: 'Pessoa' },
  { value: 'company', label: 'Empresa' },
];

export const ACTUATION_TYPES = [
  'Estudante',
  'Arquitetura',
  'Engenharia',
  'Design de Interiores',
  'Construtora/Incorporadora',
  'Outro',
];

export const BIM_LEVELS = ['Iniciante', 'Intermediário', 'Avançado', 'Especialista'];

export const SPECIALIZATIONS = [
  'Modelagem',
  'Coordenação/Compatibilização',
  'Gerenciamento BIM (BIM Manager)',
  '4D/Planejamento',
  '5D/Orçamento',
  'Sustentabilidade',
  'Facilities',
];

export const SOFTWARE = [
  'Revit',
  'ArchiCAD',
  'Navisworks',
  'AutoCAD',
  'Civil 3D',
  'Tekla',
  'SketchUp',
  'Rhino/Grasshopper',
  'Solibri',
  'Outros',
];

export const LEVEL_COLORS = {
  'Iniciante': 'bg-zinc-600 text-white',
  'Intermediário': 'bg-blue-600 text-white',
  'Avançado': 'bg-orange-600 text-white',
  'Especialista': 'bg-red-600 text-white',
};
